var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAllCategories = function SvgAllCategories(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 16.2 16.2"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#7b838f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    "data-name": "Group 4129"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.6 3.517C.6 1.329.623.6 3.517.6s2.917.729 2.917 2.917.009 2.917-2.917 2.917S.6 5.7.6 3.517",
    "data-name": "Path 2217"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.767 3.517C9.767 1.329 9.79.6 12.684.6s2.917.729 2.917 2.917.009 2.917-2.917 2.917S9.767 5.7 9.767 3.517",
    "data-name": "Path 2218"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.6 12.684c0-2.188.023-2.917 2.917-2.917s2.917.729 2.917 2.917.009 2.917-2.917 2.917S.6 14.867.6 12.684",
    "data-name": "Path 2219"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.767 12.684c0-2.188.023-2.917 2.917-2.917s2.917.729 2.917 2.917.009 2.917-2.917 2.917-2.917-.734-2.917-2.917",
    "data-name": "Path 2220"
  }))));
};
export default SvgAllCategories;